import { useTranslation } from 'react-i18next'
import { VerificationPendingIcon } from '@/common/components/icons'

export default function VerificationPendingPage() {
  const { t } = useTranslation()
  return (
    <div className="lg:max-w-3xl px-4 mx-auto py-8 flex justify-center">
      <div className="shadow-card bg-white w-4/5 space-y-4 flex flex-col items-center pt-12">
        <div>
          <VerificationPendingIcon className="h-[124px] -l80" classNameIcon="text-green-600" />
        </div>
        <h2 className="font-bold text-lg">{t('onboarding:success.title')}</h2>
        <h3 className="text-sm text-text-secondary">{t('onboarding:success.subtitle')}</h3>
        <div className="bg-green-300 text-green-600 w-full px-12 pt-6 pb-8">
          <p className="text-center whitespace-pre-line">{t('onboarding:success.description')}</p>
        </div>
      </div>
    </div>
  )
}
